import { useMutation } from "@tanstack/react-query";
import { FILE_MANAGER } from "./endpoints";
import { getRequest, postFormRequest } from "./axiosClient";

export const useUploadFile = () => {
        return useMutation({
                mutationFn: (formData) => {
                        return postFormRequest(FILE_MANAGER, formData);
                },
        });
};

export const useDeleteFile = () => {
        return useMutation({
                mutationFn: (formData) => {
                        return postFormRequest(FILE_MANAGER, formData);
                },
        });
};

export const useFetchFile = () => {
        return useMutation({
                mutationFn: ({ type, identifier }) => {
                        const queryParams = new URLSearchParams({ type, identifier });
                        return getRequest(`${FILE_MANAGER}?${queryParams.toString()}`);
                },
        });
};
